import { Back2 } from "../../../components/Option/Back";
import eugreendealicon from "../../../assets/shapes_svg/eugreendeal/eugreendeal_icon.svg";
import { useEffect, useState } from "react";
import { ContainerBody } from "../../../App";
import line from "../../../assets/shapes_svg/line_break.svg";
import "../index.css";
import "./index.css";
import {
  createHighlight,
  getHighlight,
  updateHighlight,
} from "../../../apis/Ambition";
import edit from "../../../assets/shapes_svg/roledetail/edit.svg";

export const Textareawithsteroids3 = ({
  fontReport = "14px",
  question,
  maxLength,
  keyHighlight,
  placeholder = "Please elaborate on your company experience and commitments with this proposal",
  minHeight,
  disabled = false,
  hideLimit = false,
}) => {
  const [text, setText] = useState("");
  const [unstableText, setUnstableText] = useState("");
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    handleGet();
    if (question) {
      createHighlight({ key: keyHighlight + "_question", value: question });
    }
  }, []);

  const handleGet = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setUnstableText,
    });
  };

  const handleUpdate = () => {
    if (text.length <= maxLength) {
      updateHighlight({
        key: keyHighlight,
        value: text,
        swal: false,
      });
    } else {
      setErrorMessage(
        "The text may not be longer than " + maxLength + " characters"
      );
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setText(unstableText), 1000);
    return () => clearTimeout(timer);
  }, [unstableText]);

  useEffect(() => {}, [text]);

  useEffect(() => {
    if (text != "") handleUpdate();
  }, [text]);

  return (
    <>
      {disabled ? (
        <textarea
          style={
            minHeight
              ? { minHeight: minHeight, fontSize: fontReport }
              : { fontSize: fontReport }
          }
          type="text"
          placeholder={placeholder}
          value={unstableText}
          onChange={(e) => setUnstableText(e.target.value)}
          disabled
        ></textarea>
      ) : (
        <textarea
          style={
            minHeight
              ? { minHeight: minHeight, fontSize: fontReport }
              : { fontSize: fontReport }
          }
          type="text"
          placeholder={placeholder}
          value={unstableText}
          onChange={(e) => setUnstableText(e.target.value)}
        ></textarea>
      )}
      {disabled || hideLimit ? (
        <></>
      ) : (
        <h6>
          {text.length}/{maxLength}
        </h6>
      )}
      {text.length > maxLength && errorMessage ? (
        <h6 style={{ fontSize: "0.8rem", color: "red" }}>{errorMessage}</h6>
      ) : null}
    </>
  );
};

const EUGreenDeal = () => {
  const [editTR, setEditTR] = useState(false);
  const [editCSRD, setEditCSRD] = useState(false);
  const [editCSDDD, setEditCSDDD] = useState(false);
  const [editSFDR, setEditSFDR] = useState(false);
  const [editMiFID, setEditMiFID] = useState(false);
  const [editIDD, setEditIDD] = useState(false);
  const [editUCITS, setEditUCITS] = useState(false);
  const [editAIFMD, setEditAIFMD] = useState(false);
  const [editPEF, setEditPEF] = useState(false);
  const [editEFR, setEditEFR] = useState(false);

  const defaultPlaceholder =
    "Please elaborate on your company experience and commitments with this proposal";

  const sections = [
    {
      name: "tr",
      value: editTR,
      update: setEditTR,
      html: (
        <h5>
          T.R <br />
          (Taxonomy Regulation)
        </h5>
      ),
    },
    {
      name: "csrd",
      value: editCSRD,
      update: setEditCSRD,
      html: (
        <h5>
          CSRD <br />
          (Corporate Social Responsibility Directive)
        </h5>
      ),
    },
    {
      name: "csddd",
      value: editCSDDD,
      update: setEditCSDDD,
      html: <h5>CSDDD</h5>,
    },
    {
      name: "sfdr",
      value: editSFDR,
      update: setEditSFDR,
      html: (
        <h5>
          SFDR <br />
          (Sustainable Finance Disclosure Regulation)
        </h5>
      ),
    },
    {
      name: "mifid",
      value: editMiFID,
      update: setEditMiFID,
      html: (
        <h5>
          MiFID <br />
          (Markets in Financial Instruments Directive)
        </h5>
      ),
    },
    {
      name: "idd",
      value: editIDD,
      update: setEditIDD,
      html: (
        <h5>
          IDD <br />
          (Insurance Distribution Directive)
        </h5>
      ),
    },
    {
      name: "ucits",
      value: editUCITS,
      update: setEditUCITS,
      html: <h5>UCITS</h5>,
    },
    {
      name: "aifmd",
      value: editAIFMD,
      update: setEditAIFMD,
      html: <h5>AIFMD</h5>,
    },
    {
      name: "pef",
      value: editPEF,
      update: setEditPEF,
      html: (
        <h5>
          PEF <br />
          (Product Environmental Footprint)
        </h5>
      ),
    },
    {
      name: "efr",
      value: editEFR,
      update: setEditEFR,
      html: <h5>EFR</h5>,
    },
  ];

  const euDef = (
    <>
      Climate change and environmental degradation are an existential threat to
      Europe and the world. To overcome these challenges, the European Green
      Deal will transform the EU into a modern, resource-efficient and
      competitive economy. ensuring:
      <br />
      <br />
      no net emissions of greenhouse gases by 2050 <br />
      economic growth decoupled from resource use <br />
      no person and no place left behind
      <br />
      The European Green Deal is also our lifeline out of the COVID-19 pandemic.
      One third of the €1.8 trilling investments from the NextGenerationEU
      Recovery Plan, and the EU's seven-year budget will finance the European
      Green Deal
      <br />
      <br />
      The European Commission has adopted a set of proposals to make the EUs
      climate, energy, transport and taxation plicies fit for reducing net
      greenhouse gas emissinos by at least 55% by 2030, compared to 1990 levels.
      More information on Delivering the European Green Deal.
      (commission.europa.eu/)
    </>
  );

  return (
    <ContainerBody className="ambition__body">
      <div
        className="companydetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Company Page"}
          style={{ marginRight: "auto", position: "relative", left: "-7%" }}
          to={"/ambition"}
        />
      </div>
      <div className="ambition__esg__items">
        <div
          className="ambition__role__role"
          style={{
            justifyContent: "space-around",
            flexWrap: "wrap",
            marginBottom: "50px",
          }}
        >
          <div
            className="ambition__body__item"
            style={{
              padding: "10px",
              justifyContent: "space-between",
              width: "220px",
              height: "300px",
              textAlign: "center",
            }}
          >
            <h4 style={{ marginTop: "5px" }}>E.U Green Deal</h4>
            <h5 style={{ marginBottom: "5px" }}>Continental Goals</h5>
            <img
              src={eugreendealicon}
              alt="E.U Green Deal Icon"
              style={{ margin: "5px" }}
            />
          </div>
          <div className="roleambition__bubble" style={{ textAlign: "center" }}>
            <h4>What is the E.U Green Deal?</h4>
            <h5>{euDef}</h5>
          </div>
        </div>
        <img src={line} alt="line" />
        {sections.map((directive) => (
          <div className="d-flex align-items-center justify-content-around eu__row">
            <div className="eu__bubble">{directive.html}</div>
            <div className="eu__description">
              {!directive.value ? (
                <Textareawithsteroids3
                  maxLength={3000}
                  keyHighlight={directive.name}
                  disabled={true}
                ></Textareawithsteroids3>
              ) : (
                <Textareawithsteroids3
                  maxLength={3000}
                  keyHighlight={directive.name}
                ></Textareawithsteroids3>
              )}
            </div>
            <img
              src={edit}
              alt=""
              onClick={() => directive.update(!directive.value)}
            />
          </div>
        ))}
      </div>
    </ContainerBody>
  );
};

export default EUGreenDeal;
